import React from 'react'
import { useHistory } from 'react-router-dom'
import Table from 'components/Shared/Table'
import { columns } from 'components/UserGroups/UserGroupsTable/columns'
import { deleteUserGroup, fetchUserGroupsPage } from 'services/UserGroupsService'
import { HTTP_404_ERROR } from 'Constants'
import { useErrorHandling } from 'context/errorHandling'
import { useAuth, USER_GROUP_CREATE, USER_GROUP_DELETE, USER_GROUP_EDIT } from 'context/auth'
import { useTranslation } from 'react-i18next'
import styles from './UserGroupsTable.module.css'

export function UserGroupsTable () {
  const history = useHistory()
  const { hasAnyPrivileges } = useAuth()
  const { handleError } = useErrorHandling()
  const { t } = useTranslation()

  const addGroup = () => {
    history.push('/user-groups/create')
  }

  const editGroup = (row) => {
    if (!hasAnyPrivileges([USER_GROUP_EDIT])) return
    history.push('/user-groups/edit/' + row.id)
  }

  const onDeleteError = (error) => {
    handleError(error, {
      [HTTP_404_ERROR]: 'notifications.error.delete'
    })
  }

  const copyGroup = row => {
    history.push({
      pathname: '/user-groups/create',
      state: { idOfCopiedGroup: row.id }
    })
  }

  const addButton = {
    label: 'userGroups.table.addButtonLabel',
    onClick: addGroup,
    isClickable: hasAnyPrivileges([USER_GROUP_CREATE])
  }

  const menuOptions = {
    copy: {
      onClick: copyGroup,
      isCopyable: () => hasAnyPrivileges([USER_GROUP_CREATE])
    },
    delete: {
      onDelete: deleteUserGroup,
      onDeleteError: onDeleteError,
      deleteDialog: {
        content: 'userGroups.table.deleteDialog.content',
        title: 'userGroups.table.deleteDialog.title'
      },
      isDeletable: () => hasAnyPrivileges([USER_GROUP_DELETE])
    }
  }

  return (
    <Table title={'userGroups.table.title'}
           addButton={addButton}
           fetchData={fetchUserGroupsPage}
           columns={columns}
           tableKey={'userGroups'}
           renderToolbarLeftPanel={() =>
             <div className={styles.info}>{t('userGroups.table.info')}</div>
           }
           onRowClick={editGroup}
           menu={menuOptions}
    />
  )
}
